
/*
 *
 * Date: 2025
 * Description: List drawer component for detailing items in a list
 * Author: Philippe Leroux @SKITSC
 *
 */

//Modules
import { Fragment, ReactElement, useState } from "react";
import { Box, IconButton, Typography , Grid , Checkbox, Collapse } from "@mui/material"

//Interfaces
import { i_parts } from "../../interfaces/items.interface"
import { i_drawer_list_card, i_part_card_props } from "../../interfaces/display.interfaces"

//Icons
import ExpandLessIcon from '@mui/icons-material/ExpandLess';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import ManageHistoryIcon from '@mui/icons-material/ManageHistory';

//Components
import PartCard from "./part.card";
import CountBaseCost from "../utils/count.base";

//Utils
import { timestampToDate } from "../../utils/utility";
import { default_search } from "../../utils/constant";

const ListDrawer = ( props : i_drawer_list_card ) : ReactElement => {
    const [ open , setOpen ] = useState<boolean>(false)
    const part_props : i_part_card_props = {
        callback : () => {},
        addPart : () => {},
        path : props.path,
        type : 'view'
    }
    const countTotal = () : string => {
        if (props.list.history.length > 0) {
            let total = 0;

            for (let i = 0; i < props.list.history[0].order.length; i++) {
                const price = props.list.history[0].order[i].price;

                if (price !== null && !isNaN(Number(price))) {
                    total += Number(price);
                }
            }

            return total.toFixed(2); 
        } else {
            return '';
        }
    }
    const title = { fontWeight : 700 , fontSize : 18}
    const RenderOrderDate = () : ReactElement => {
        return (
            <Box>
                {props.list.history.length > 0 ?
                    <Box>
                        {timestampToDate(props.list.history[0].timestamp , 'long')}
                    </Box>
                    :
                    <Typography>
                            {props.list.items.length} items
                    </Typography>
                }
            </Box>
        )
    }
    return (
        <Box sx={{ width : '100%' , height : '100%'}}>
            <Box sx={{ border : open ? '1px solid black' :'1px solid #EAECF0' , padding : 1 , maxWidth : '1400px' , marginLeft : 'auto' , marginRight : 'auto' , borderBottom : open ? '0px solid black' : '1px solid #EAECF0' }}>
                <Grid container>
                    <Grid size={1}>
                        <Checkbox checked={props.list?.admin_selected ? props.list.admin_selected : false} sx={{ padding :1 , width : 50 , border : 0}} onChange={() => props.selectedCb(props.list)} />
                    </Grid>
                    <Grid size={2} sx={{ alignContent : 'center'}}>
                            <RenderOrderDate />
                    </Grid>
                    <Grid size={1.5} sx={{ alignContent : 'center'}}>
                        <Typography sx={{ textDecoration : 'underline' , fontWeight : 700}}>
                            {props.list.order_number}
                        </Typography>
                    </Grid>
                    <Grid size={1.5} sx={{ alignContent : 'center'}}>
                        <Typography sx={{ color : props.list.status === 'pending' ? 'red' : props.list.status === 'transit' ? 'purple' : props.list.status === 'cancelled' ? 'blue' : props.list.status === 'completed' ? 'green' : 'black'}}>
                            {props.list.status}
                        </Typography>
                    </Grid> 
                    <Grid size={2} sx={{ alignContent : 'center'}}>
                        <Typography sx={{ textDecoration : 'underline' }}>
                            {props.list.items.length} items
                        </Typography>
                    </Grid>
                    <Grid size={3} sx={{ alignContent : 'center' , display : 'flex'}}>
                        <Typography sx={{ alignSelf : 'center'}}>{countTotal()}$ ---</Typography>
                        <CountBaseCost {...props.list} />
                    </Grid>
                    <Grid size={1}>
                        <IconButton onClick={() => props.callback(props.list , 'form' , props.user)}>
                            <ManageHistoryIcon color={'primary'} />
                        </IconButton>
                        <IconButton onClick={() => setOpen(open ? false : true)}>
                            {open ? <ExpandLessIcon /> : <ExpandMoreIcon />}
                        </IconButton>
                    </Grid>
                </Grid>
            </Box>
            <Box sx={{ maxWidth : '1400px' , marginLeft : 'auto' , marginRight : 'auto' }}>
                <Collapse in={open} timeout="auto">
                    <Fragment>
                        {props.list.status !== 'initial' &&
                            <Box sx={{ display: 'flex', flexWrap: 'wrap', border: open ? '1px solid black' : '1px solid #EAECF0', padding: 2, rowGap: 1, borderTop : 'none' , borderBottom : 'none'  }} >
                                <Box sx={{ display: 'flex', gap: 1, flex: '1 1 50%' }}>
                                    <Typography sx={title}>Po number:</Typography>
                                    <Typography>{props.list.po}</Typography>
                                </Box>
                                <Box sx={{ display: 'flex', gap: 1, flex: '1 1 50%' }}>
                                    <Typography sx={title}>Additional notes:</Typography>
                                    <Typography>{props.list.comment}</Typography>
                                </Box>
                            </Box>
                        }
                        {props.list.items.map((item : i_parts , index : number) => (
                            <Box key={index}>                    
                                <PartCard in={false} {...part_props} part={item} rendering={false} filter={default_search}  />
                            </Box>
                        ))}
                    </Fragment>
                 
                </Collapse>
            </Box>
              
        </Box>
    )
}

export default ListDrawer